import { createActions } from 'redux-actions'

export const {
  getSearchCategoriesSucceeded,
  getHomeCategoriesSucceeded
} = createActions({
  GET_SEARCH_CATEGORIES_SUCCEEDED: normalized => normalized,
  GET_HOME_CATEGORIES_SUCCEEDED: normalized => normalized
})
